// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import FlashController from "./flash_controller"
import PasswordVisibility from "@stimulus-components/password-visibility"
application.register("flash", FlashController)
application.register("password-visibility", PasswordVisibility)
